import {
  useDataModel,
  params,
  string,
  shape,
  arrayOf,
  bool,
  typename,
} from '@thd-nucleus/data-sources';

export const useMediaContent = ({
  slug,
  entryId, // used for preview
  skip
}) => {

  // We only want to query for slug OR entryId
  // using both in the graphQL call will throw an error
  const queryVars = entryId
    ? {
        slug: "",
        entryId,
      }
    : { slug, entryId: "" };

  const { data, loading, error } = useDataModel('mediaContent', {
    variables: queryVars,
    skip: skip || (!slug && !entryId)
  });

  return { data, loading, error };
};

useMediaContent.dataModel = {
  mediaContent: params({
    // Can only use one or the other
    slug: string(),
    entryId: string(),
  }).shape({
    entryId: string(),
    title: string(),
    slug: string(),
    layouts: arrayOf(
      shape({
        entryId: string(),
        slots: arrayOf(
          shape({
            id: string(),
            entryId: string(),
            title: string(),
            type: string(),
            mediaCollections: arrayOf(
              shape({
                entryId: string(),
                subtitle: string(),
                theme: string(),
                title: string(),
                customProps: string(),
                description: string(),
                media: arrayOf(
                  shape({
                    entryId: string(),
                    title: string(),
                    subtitle: string(),
                    seo: bool(),
                    isAutoplay: bool(),
                    eyebrow: string(),
                    icon: string(),
                    richText: string(),
                    callToAction: string(),
                    anchorId: string(),
                    schema: string(),
                    theme: string(),
                    isCarousel: bool(),
                    isSponsored: bool(),
                    description: string(),
                    stencilIcon: string(),
                    customProps: string(),
                    sourceDesktop: arrayOf(
                      shape({
                        entryId: string(),
                        title: string(),
                        customProps: string(),
                        type: string(),
                        uri: string(),
                        hyperlink: string(),
                        dimensions: string(),
                        hotspot: string(),
                        altText: string(),
                      }),
                    ),
                    sourceMobile: arrayOf(
                      shape({
                        entryId: string(),
                        title: string(),
                        customProps: string(),
                        type: string(),
                        uri: string(),
                        hyperlink: string(),
                        dimensions: string(),
                        altText: string(),
                        hotspot: string(),
                      }),
                    ),
                  }),
                ),
              }),
            ),
            __typename: typename('newSlot'),
          }),
        ),
      })),
    __typename: typename('mediaContent'),
  }),
};
